import { useCallback, useEffect, useState } from "react";
import logoLight from "/logo-light.png";

export function useNotificationPermissions() {
    const [hasPermission, setHasPermission] = useState(() =>
        typeof window !== "undefined" && "Notification" in window ? Notification.permission === "granted" : false
    );

    const requestPermissions = useCallback(() => {
        if ("Notification" in window) {
            void Notification.requestPermission().then(function (permission) {
                if (permission === "granted") {
                    setHasPermission(true);
                }
            });
        } else {
            console.debug("Notificaties worden niet ondersteund door deze browser.");
        }
    }, [setHasPermission]);

    useEffect(() => {
        let status: PermissionStatus | null = null;

        const setup = async () => {
            if (!("permissions" in navigator)) return;

            status = await navigator.permissions.query({ name: "notifications" });

            setHasPermission(status.state === "granted");

            status.onchange = () => {
                console.debug("Notification permissions changed", status!.state);
                setHasPermission(status?.state === "granted");
            };
        };

        void setup();

        return () => {
            if (status) status.onchange = null;
        };
    }, []);

    return [hasPermission, requestPermissions] as const;
}

export function useSendNotifications() {
    const [hasPermission] = useNotificationPermissions();

    return useCallback(
        (title: string, body: string, onlyWhenUnfocussed = true) => {
            const shouldSend = onlyWhenUnfocussed ? !window.document.hasFocus() : true;
            if (shouldSend && hasPermission) {
                new Notification(title, { body, icon: logoLight, requireInteraction: true });
            }
        },
        [hasPermission]
    );
}
